import getSymbolFromCurrency from 'currency-symbol-map';
import { useEffect, useState } from 'react';

export function usePriceApi() {
  const [priceString, setPriceString] = useState('');

  useEffect(() => {
    void fetch(`${process.env.NX_PUBLIC_API_URL}/config`, {
      method: 'GET',
    }).then(async (response) => {
      const { payment } = await response.json();
      setPriceString(getPriceString(payment.amountInCents, payment.currency));
    });
  }, []);

  function getPriceString(priceInCents: string, currency: string) {
    let price = String(Number(priceInCents) / 100);
    if (currency === 'EUR') {
      price = price.replace('.', ',');
    }
    const currencySymbol = getSymbolFromCurrency(currency);
    return price + ' ' + currencySymbol;
  }

  return priceString;
}
